import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=87736dfe&scoped=true&lang=pug&"
import script from "./RegistrationForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=87736dfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87736dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VSelect,VTextField})
